export enum NotificationDeliveryWindow {
    UNSPECIFIED = 'notification_delivery_window_unspecified',
    STANDARD = 'STANDARD',
    TIMEZONE = 'TIMEZONE',
    INFORMED = 'INFORMED',
    HOLD_OUT = 'HOLD_OUT',
}
